import { useEffect, useState } from 'react'

export interface PublicReview {
  id: number
  name: string
  role: string
  company: string
  content: string
  rating: number
}

function normalizeReview(review: Record<string, unknown>): PublicReview {
  const rating = Number(review.rating)
  return {
    id: Number(review.id),
    name: String(review.name || 'Client'),
    role: String(review.role || 'Client'),
    company: String(review.company || 'Advict Spatial Consult'),
    content: String(review.content || review.comment || ''),
    rating: Number.isFinite(rating) ? Math.max(1, Math.min(5, rating)) : 5,
  }
}

export function useReviews() {
  const [reviews, setReviews] = useState<PublicReview[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const controller = new AbortController()

    async function loadReviews() {
      try {
        const response = await fetch('/api/reviews', { signal: controller.signal })
        if (!response.ok) throw new Error('Unable to load reviews')
        const data: unknown = await response.json()
        if (Array.isArray(data)) setReviews(data.map((review) => normalizeReview(review as Record<string, unknown>)))
      } catch (error) {
        if ((error as Error).name !== 'AbortError') console.error('Failed to load reviews:', error)
      } finally {
        if (!controller.signal.aborted) setIsLoading(false)
      }
    }

    loadReviews()
    return () => controller.abort()
  }, [])

  return { reviews, isLoading }
}
